export default "__VITE_ASSET__107a1d20__"